export const VENDOR_DETAILS_CHANGE_TRACKING = {
  vendorDetailsDetails: {
    source: 'vendor_details.details',
    id: 16001,
  },
  vendorDetailsOperatingLocations: {
    source: 'vendor_details.operating_locations',
    id: 16002,
  },
  vendorDetailsCreate: {
    source: 'vendor_details.create',
    id: 16101,
  },
  vendorDetailsDocumentsDelete: {
    source: 'vendor_details.documents.delete',
    id: 16102,
  },
  vendorDetailsDocumentsUpload: {
    source: 'vendor_details.documents.upload',
    id: 16103,
  },
  vendorDetailsInternalNotesAdd: {
    source: 'vendor_details.internal_notes.add',
    id: 16104,
  },
  vendorDetailsInternalNotesDelete: {
    source: 'vendor_details.internal_notes.delete',
    id: 16105,
  },
  vendorDetailsInternalNotesUpdate: {
    source: 'vendor_details.internal_notes.update',
    id: 16106,
  },
  vendorDetailsSyncWithIntacct: {
    source: 'vendor_details.sync_with_intacct',
    id: 16107,
  },
} as const;
